import { Component, ElementRef, OnInit, Output, Input, EventEmitter, OnDestroy, ViewChild} from "@angular/core";
//import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";
//import * as _ from "underscore";
//import { CameraLocation } from "src/models/camera-location";
import { environment } from "../environments/environment";
import { loadModules } from "esri-loader";
import esri = __esri; // Esri TypeScript Types
//import { element } from 'protractor';
//import { Point } from 'esri/geometry';
import { VideoRequest } from 'src/models/video-request';
import Color from "@arcgis/core/Color";

@Component({
  selector: "esri-map",
  templateUrl: "esri-map.html",
  styleUrls: ["esri-map.css"]
})
export class EsriMap implements OnInit, OnDestroy {
  @Output() mapLoadedEvent = new EventEmitter<boolean>();
  @Output() pickedCameraEvent = new EventEmitter<any[]>();
  @Input() isMobile: boolean = false;
  // The <div> where we will place the map
  @ViewChild("mapViewNode", { static: true }) private mapViewEl!: ElementRef;
  _loaded = false;
  _cameraIcon: esri.PictureMarkerSymbol; // Regular Camera Icon
  _cameraSelectedIcon: esri.PictureMarkerSymbol; // Selected Camera Icon
  commonExtents: any[] = [];
  instructionsExpand: any; // Show/Hide Map Instructions.
  invalidSymbol: any;
  cameras: any[] = []; // List of all cameras
  camerasSelected: any[] = [];
  camerasFeatureLayer: esri.FeatureLayer; // Cameras Features Layer
  camerasGraphicsLayer: any; // Cameras Graphics Layer
  sketchGraphicsLayer: esri.GraphicsLayer; // Sketch Graphics Layer
  formLayer: any; // Form submission layer
  cameraGraphics: any[] = [];
  spatialRef: esri.SpatialReference; // Spatial Reference default
  localView: esri.MapView; // EsriMapView
  localMap: any; // EsriMap
  num_cams_selected: number = 0; // total  # of cameras selected
  selectedCamera: any;
  sketchBoxCameras: any;
  cameraRender: any;
  camerasExtent: any;

  public async resetMap() {
    await this.clearAllCameras();

    var opts = {
      duration: 5000  // Duration of animation will be 5 seconds
    };

    // go to point at LOD 15 with custom duration
    this.localView.goTo({
      center: [-93, 42],
      zoom: 7,
    }, opts);

  }

  public async centerAndZoomToCameras() {
    const [
      GraphicsLayer,
      EsriMap,
      EsriMapView,
      Extent,
      Point,
    ] = await loadModules([
      "esri/layers/GraphicsLayer",
      "esri/Map",
      "esri/views/MapView",
      "esri/geometry/Extent",
      "esri/geometry/Point"
    ]);

    this.camerasExtent = null;

    if(this.camerasSelected.length === 1) {
      let xOffset = 6153;
      let yOffset = 4013;
      this.camerasExtent = new Extent(this.camerasSelected[0].geometry.x - xOffset,this.camerasSelected[0].geometry.y - yOffset,this.camerasSelected[0].geometry.x + xOffset,this.camerasSelected[0].geometry.y + yOffset,this.spatialRef);
    } else {
      for(let i=0; i < this.camerasSelected.length; i++) {
        if (!this.camerasExtent) {
          this.camerasExtent = new Extent(this.camerasSelected[i].geometry.x,this.camerasSelected[i].geometry.y,this.camerasSelected[i].geometry.x,this.camerasSelected[i].geometry.y,this.spatialRef);
        } else {
          let next = new Extent(this.camerasSelected[i].geometry.x,this.camerasSelected[i].geometry.y,this.camerasSelected[i].geometry.x,this.camerasSelected[i].geometry.y,this.spatialRef);
          this.camerasExtent.union(next);
        }
      }
    }

    await this.localView.goTo(this.camerasExtent);
    this.localView.zoom -= 1;
  }

  public async submitForm(form: VideoRequest): Promise<boolean> {
    const [
      Graphic,
      FeatureLayer,
      ErsiMapView,
      Extent,
      Polygon
    ] = await loadModules([
      "esri/Graphic",
      "esri/layers/FeatureLayer",
      "esri/views/MapView",
      "esri/geometry/Extent",
      "esri/geometry/Polygon"
    ]);

    //attributes for the feature
    var attr = {
      NAME: form.NAME,
      COMPANY: form.COMPANY,
      EMAIL: form.EMAIL,
      PHONE: form.PHONE,
      ADDITIONAL_INFO: form.ADDITIONAL_INFO,
      REASON: form.REASON,
      CAMERAS: form.CAMERAS,
      TIME_START: form.TIME_START,
      TIME_END: form.TIME_END,
      USER_TYPE: form.USER_TYPE,
      START_TIME: form.START_TIME,
      END_TIME: form.END_TIME,
      Fatality: form.Fatality,
      Urgent: form.Urgent ? 1 : 0
  };

  if(this.camerasExtent.width === 0 || this.camerasExtent.height === 0)
  {
    var geom = new Polygon({
      rings: [
        [this.localView.extent.xmax, this.localView.extent.ymax],
        [this.localView.extent.xmin, this.localView.extent.ymax],
        [this.localView.extent.xmin, this.localView.extent.ymin],
        [this.localView.extent.xmax, this.localView.extent.ymin]
      ],
      spatialReference: this.spatialRef
  });
  }
  else
  {
    var geom = new Polygon({
      rings: [
        [this.camerasExtent.xmax, this.camerasExtent.ymax],
        [this.camerasExtent.xmin, this.camerasExtent.ymax],
        [this.camerasExtent.xmin, this.camerasExtent.ymin],
        [this.camerasExtent.xmax, this.camerasExtent.ymin]
      ],
      spatialReference: this.spatialRef
  });
  }


  var feature = new Graphic({
    geometry: geom,
    attributes: attr
  });

  let isValid = false;
  console.info(feature);
  var promise = this.formLayer.applyEdits({ addFeatures: [feature]})
  promise.then((x: any) => {
    if(x.addFeatureResults.length > 0) {
      if(x.addFeatureResults[0].error === null)
        isValid = true;
      else
        console.error(x.addFeatureResults[0].error);
    }
  });

  await promise;

  return isValid;
  }

  async clearAllCameras() {
    const [
      Graphic,
      GraphicsLayer,
      PictureMarkerSymbol,
    ] = await loadModules([
      "esri/Graphic",
      "esri/layers/GraphicsLayer",
      "esri/symbols/PictureMarkerSymbol",
    ]);

    for(let i = 0; i < this.camerasSelected.length; i++) {
      let c = this.camerasSelected[i];
      let g = this.camerasGraphicsLayer.graphics.items.filter((element: any) => {
        if(element.attributes && element.attributes.FID === c.attributes.FID)
          return element;
      })[0];

      g.symbol = this._cameraIcon;
    }

    this.camerasSelected = [];
    this.pickedCameraEvent.emit(this.camerasSelected);

    return true;
  }

  async extentCameras() {
    const [
      Graphic,
      GraphicsLayer,
      PictureMarkerSymbol,
      EsriMap,
      EsriMapView,
      Extent,
      Draw,
      DrawAction,
      PolygonDrawAction,
      Sketch
    ] = await loadModules([
      "esri/Graphic",
      "esri/layers/GraphicsLayer",
      "esri/symbols/PictureMarkerSymbol",
      "esri/Map",
      "esri/views/MapView",
      "esri/geometry/Extent",
      "esri/views/draw/Draw",
      "esri/views/draw/DrawAction",
      "esri/views/draw/PolygonDrawAction",
      "esri/widgets/Sketch"
    ]);

    this.sketchBoxCameras.create("rectangle", { mode: "freehand" });

    // listen to create event, only respond when event's state changes to complete
    this.sketchBoxCameras.on("create", (event: any) => {
      if (event.state === "complete") {
      // remove the graphic from the layer associated with the Sketch widget
      // instead use the polygon that user created to query features that
      // intersect it.
      let theBox = event.graphic.geometry.extent;

      this.camerasGraphicsLayer.graphics.items.forEach((element: any) => {
        if(element.geometry) {
          if(theBox.xmin <= element.geometry.x && theBox.xmax >= element.geometry.x &&
            theBox.ymin <= element.geometry.y && theBox.ymax >= element.geometry.y) {
            // Camera within view.
            let existing = this.camerasSelected.filter(sc => {
              if(sc.attributes && sc.attributes.FID === element.attributes.FID)
                return sc;
            });
            if(existing.length === 0) {
              element.symbol = this._cameraSelectedIcon;
              this.camerasSelected.push(element);
            } else {
              // just make sure it is orange.
              element.symbol = this._cameraSelectedIcon;
            }
          }
        }
      });

      this.sketchGraphicsLayer.remove(event.graphic);
      this.pickedCameraEvent.emit(this.camerasSelected);
    }
  });
}

  async initializeMap() {
    try {
      // Load the modules for the ArcGIS API for JavaScript
      const [
        esriConfig,
        EsriMap,
        Portal,
        EsriMapView,
        BasemapGallery,
        Locate,
        SpatialReference,
        Search,
        Expand,
        Extent,
        GraphicsLayer,
        FeatureLayer,
        Sketch
        //,Locator
      ] = await loadModules([
        "esri/config",
        "esri/Map",
        "esri/portal/Portal",
        "esri/views/MapView",
        "esri/widgets/BasemapGallery",
        "esri/widgets/Locate",
        "esri/geometry/SpatialReference",
        "esri/widgets/Search",
        "esri/widgets/Expand",
        "esri/geometry/Extent",
        "esri/layers/GraphicsLayer",
        "esri/layers/FeatureLayer",
        "esri/widgets/Sketch"
        //,"esri/tasks/Locator"
      ]);

      this.spatialRef = new SpatialReference({ wkid: 102100 });
      // If you define the Portal URL in esriConfig, the
      // basemapGallery widget can determine which basemaps
      // to use.
      esriConfig.portalUrl = "https://jsapi.maps.arcgis.com";

      this.commonExtents = [
        {
          name: "Ames",
          extent: new Extent(-10440075.165539281,5157753.036910276,-10402812.114250308,5173040.44256729,this.spatialRef)
        },
        {
          name: "Council Bluffs",
          extent: new Extent(-10677230.608956683,5046552.379910708,-10658599.083312199,5054196.082739216,this.spatialRef)
        },
        {
          name: "Des Moines",
          extent: new Extent(-10464357.02123033,5086186.877664355,-10389830.918652384,5116761.688978384,this.spatialRef)
        },
        {
          name: "Iowa City",
          extent: new Extent(-10209122.478719167,5104205.438416672,-10171859.427430194,5119492.844073686,this.spatialRef)
        },
        {
          name: "Sioux City",
          extent: new Extent(-10742066.145542987,5228207.017233162,-10704803.094254013,5243494.422890176,this.spatialRef)
        },
        {
          name: "Quad Cities",
          extent: new Extent(-10120063.588839816,5080203.916468935,-10045537.486261869,5110778.727782965,this.spatialRef)
        },
        {
          name: "Waterloo",
          extent: new Extent(-10297808.295929024,5227816.031032599,-10260545.24464005,5243103.436689612,this.spatialRef)
        }
      ];

      // Intialize a portal instance and load it
      var portal = new Portal();
      // point to <div id=map>
      var mapDiv = this.mapViewEl.nativeElement;
      // wait till portal is loaded; Cannont access class elements within load function
      await portal.load();
      try {
        // Configure the Map
        const mapProperties: esri.MapProperties = {
          basemap: "osm"  // Open Streets Map
        };

        // initialize the map
        this.localMap = new EsriMap(mapProperties);

        // properties of the MapView
        const mapViewProperties: esri.MapViewProperties = {
          container: mapDiv,
          center: [-93, 42],
          zoom: 7,
          spatialReference: this.spatialRef,
          map: this.localMap,
          popup: {
            dockEnabled: false, 
            //featureNavigationEnabled: false
          },
          highlights: 
            [{name: "default", color: new Color([212, 98, 0, 1])}]
          
        };

        //const AmesButton = document.createElement("button");
        //AmesButton.innerHTML = "Ames"
        //AmesButton.className = "esri-button esri-button-overwrite";
        //AmesButton.addEventListener("click", () =>{this.metroClick('Ames')})



        // Initialize the MapView
        this.localView = new EsriMapView(mapViewProperties);
        // The BasemapGallery will use the basemaps
        // configured by the Portal URL defined in esriConfig.portalUrl
        //this.localView.ui.add(AmesButton, "bottom-right");
        const basemapGallery = new BasemapGallery({
          view: this.localView
        });
        // initialize cameras layer
        this.camerasFeatureLayer = new FeatureLayer({
          url: environment.cameraLocationsUrl,
          outFields: ["*"],
          visible: false
        });

        // initialize camera form submission
        this.formLayer = new FeatureLayer({
          url: environment.request_url
        });

        this.camerasGraphicsLayer = new GraphicsLayer({
          minScale: 8055324,
        });

        this.sketchGraphicsLayer = new GraphicsLayer();

        this.localMap.add(this.camerasGraphicsLayer);
        this.localMap.add(this.sketchGraphicsLayer);
        // Instructions expand widget
        const sampleInstructions = document.getElementById("instructions");
        this.instructionsExpand = new Expand({
          expandIconClass: "esri-icon-question",
          expandTooltip: "How to use this sample",
          expanded: false,
          view: this.localView,
          content: sampleInstructions
        });
        this.localView.ui.add(this.instructionsExpand, "top-left");
        // Location Button
        const locateBtn = new Locate({
          view: this.localView
        });
        this.localView.ui.add(locateBtn, { position: "top-left" });
        // Map Expand Button
        var bgExpand = new Expand({
          view: this.localView,
          content: basemapGallery
        });

        //var customSearchSource = {
        //  locator: new Locator({ url: "https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer" }),
        //  singleLineFieldName: "SingleLine",
        //  name: "World Geocoding Service",
        //  placeholder: "Search Geocoder",
        //  maxResults: 3,
        //  maxSuggestions: 6,
        //  suggestionsEnabled: false,
        //  minSuggestCharacters: 0,
        //  countryCode: "US",
        //  withinViewEnabled: true,
        //};

        this.localView.ui.add(bgExpand, "bottom-left");
        // The Search widget will also use the locators
        // configurned by the Portal URL defied in esriConfig.portalUrl
        
       // var search = new Search({
        //  view: this.localView,
       //   sources: [customSearchSource],
        //  searchAllEnabled: false,
        //  includeDefaultSources: false
       //  });
       // this.localView.ui.add(search, "top-right");
        
        // With version 4.7 the search widget's onfocusout handler will throw an error
        // whenever there is a jQuery onfocusout handler along the event path because of
        // jQuery's event bubbling workaround for focusin/out events. So for now, just
        // remove the Search widget's onfocusout handler to silence the error.
        
        //const handler = search.on('search-focus', (event: any) => {
        //  handler.remove();
        //  const input = event.target.container.querySelector('.esri-search__input');
        //  if (input) {
        //    input.onfocusout = null;
        //  }
       // });


        this.sketchBoxCameras = new Sketch({
          layer: this.sketchGraphicsLayer,
          view: this.localView
        });
      } catch (error) {
        console.warn("EsriLoader: ", error);
        throw error;
      }

      await portal.when();
      await this.localView.when();

      // Mouse click event on map
      this.localView.on("click", (event:any) => {
        // see if user clicked a camera icon
        this.localView.hitTest(event).then( (response: any) => {
          // If a user clicks on an camera icon, select the camera.
          if (response.results[0].graphic && response.results[0].graphic.attributes.FID) {
            let c = response.results[0].graphic;
            let match = this.camerasSelected.filter(item => {
              if(item.attributes && item.attributes.FID === c.attributes.FID)
               return item;
            });
            if(match.length === 0) {
              // Camera is not selected
              c.symbol = this._cameraSelectedIcon;
              this.camerasSelected.push(c);
            } else {
              let i = this.camerasSelected.map(x => {
                if(x.attributes && x.attributes.FID)
                  return x.attributes.FID;
                else
                  return null;
              }).indexOf(c.attributes.FID);
              this.camerasSelected.splice(i, 1);
              c.symbol = this._cameraIcon;
            }

            this.pickedCameraEvent.emit(this.camerasSelected);
          }
        });
      });

      return this.localView;
    } catch (error) {
      console.warn("EsriLoader: ", error);
      throw error;
    }
  }

  // Loads all camera locations to the map
  async loadAllCamerasToCameraLayer() {
    const [
      SpatialReference,
      SimpleRenderer,
      FeatureLayer,
      Graphic,
      GraphicsLayer,
      PictureMarkerSymbol,
      PopupTemplate
    ] = await loadModules([
      "esri/geometry/SpatialReference",
      "esri/renderers/SimpleRenderer",
      "esri/layers/FeatureLayer",
      "esri/Graphic",
      "esri/layers/GraphicsLayer",
      "esri/symbols/PictureMarkerSymbol",
      "esri/PopupTemplate"
    ]);
    this._cameraIcon = new PictureMarkerSymbol({url: "./assets/camera.png",width: 20,height: 20});
    this._cameraSelectedIcon = new PictureMarkerSymbol({url: "./assets/camera_sel.png",width: 20,height: 20});

    let template = {};

    if(this.isMobile) {
      template = {
        title: 'Click to View Image',
        location: location,
        content: '{Desc_}<br/><table><tr><td style="min-width: 200px;"><a href="{ImageURL}" target="_blank"><img alt="camera view not available" src="{ImageURL}" style="width: 200px;" class="popup-camera-image" /></a></td><td class="text-center"><h5>View may be different at time of recording.</h5></td></tr></table>'
      }
    } else {
      template = {
        title: '{Desc_}',
        location: location,
        content: '<table><tr><td style="min-width: 200px;"><a href="{ImageURL}" target="_blank"><img alt="camera view not available" src="{ImageURL}" style="width: 200px;" class="popup-camera-image" /></a></td><td class="text-center"><span style="font-size: .83em; font-weight: bold;">View may be different at time of recording.</span></td></tr></table>'
      }
    }


    let pop = new PopupTemplate(template);

    this.camerasFeatureLayer.queryFeatures({
      //where: "ORG='IADOT' AND RECORDED='Y'",
      where:"RECORDED='Y' OR RECORDED='E'",
      outSpatialReference: new SpatialReference({ wkid: 102100 }),
      returnGeometry: true,
      outFields: ["*"],
    }).then((results: any) => {
      // Cannot modify Feature Layer. So putting all features into Graphics Layer.
      if (results.features.length > 0) {
        results.features.forEach((element: any) => {
          let g = new Graphic({
            attributes: element.attributes,
            geometry: element.geometry,
            symbol: this._cameraIcon,
            popupTemplate: pop,
          });
          this.cameraGraphics.push(g);
        });
        this.camerasGraphicsLayer.graphics = this.cameraGraphics;
      }
    });
  }

  metroClick(name: string) {
    var item = this.commonExtents.filter(x => x.name === name)[0];
    this.localView.goTo(item.extent);
  }

  //TODO: remove IsSelected in graphic attribute. Just change symbol. Keep track in different list.

  async selectCamerasInView() {
    const [
      Graphic,
      GraphicsLayer,
      PictureMarkerSymbol,
      EsriMap,
      EsriMapView,
      Extent,
    ] = await loadModules([
      "esri/Graphic",
      "esri/layers/GraphicsLayer",
      "esri/symbols/PictureMarkerSymbol",
      "esri/Map",
      "esri/views/MapView",
      "esri/geometry/Extent",
    ]);

    const e = this.localView.extent;
    this.camerasGraphicsLayer.graphics.items.forEach((element: any) => {
      if(element.geometry) {
        if(e.xmin <= element.geometry.x && e.xmax >= element.geometry.x &&
          e.ymin <= element.geometry.y && e.ymax >= element.geometry.y) {
          // Camera within view.
          let existing = this.camerasSelected.filter(sc => {
            if(sc.attributes && sc.attributes.FID === element.attributes.FID)
              return sc;
          });
          if(existing.length === 0) {
            element.symbol = this._cameraSelectedIcon;
            this.camerasSelected.push(element);
          } else {
            // just make sure it is orange.
            element.symbol = this._cameraSelectedIcon;
          }
        }
      }
    });

    this.pickedCameraEvent.emit(this.camerasSelected);
  }

  ngOnInit() {
    // Initialize MapView and return an instance of MapView
    this.initializeMap().then(mapView => {
      // The map has been initialized
      this._loaded = this.localView.ready;
      this.loadAllCamerasToCameraLayer().then(result => {
        this.mapLoadedEvent.emit(true);
      });
    });
  }

  ngOnDestroy() {
    if (this.localView) {
      // destroy the map view
      this.localView.container = null;
    }
  }
}